<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="work-flow-sta-title" :field="fields?.title" tag="h2" />
      <div class="work-flow-sta-content" v-if="fields?.stepImage">
        <div class="work-flow-sta-content-card">
          <div
            class="work-flow-sta-content-card-item"
            v-for="(item, index) in fields?.cardList"
            :key="index"
            :style="{
              background: item?.fields?.bgColor?.value,
            }"
          >
            <JssRichText :field="item?.fields?.text" />
          </div>
        </div>
        <AdaptiveImage
          class="work-flow-sta-content-stepimage"
          :field="fields?.stepImage"
          :isBackground="false"
          :lazy-load="false"
          :enableScrollDetection="false"
          :show="true"
        />
        <div class="work-flow-sta-content-step" v-if="fields?.stepList?.length > 0">
          <div
            class="work-flow-sta-content-step-item"
            v-for="(item, index) in fields?.stepList"
            :key="index"
          >
            <JssRichText :field="item?.fields?.text" />
          </div>
        </div>
        <div class="work-flow-sta-content-foot" v-if="fields?.footList?.length > 0">
          <div
            class="work-flow-sta-content-foot-item"
            v-for="(item, index) in fields?.footList"
            :key="index"
          >
            <div class="work-flow-sta-content-foot-item-title">
              <JssRichText :field="item?.fields?.title" />
            </div>
            <JssRichText
              class="work-flow-sta-content-foot-item-subtitle"
              :field="item?.fields?.subtitle"
              tag="p"
            />
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'WorkflowSta',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'work-flow-sta'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.work-flow-sta {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow: auto;
    margin-top: 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    &-card {
      display: flex;
      align-items: center;
      gap: 15px;
      width: 1135px;

      &-item {
        font-size: 14px;
        line-height: 1.2;
        font-weight: 700;
        color: #0f172a;
        height: 40px;
        border-radius: 8px;
        line-height: 40px;
        text-align: center;

        &:nth-child(1) {
          flex: 1;
        }

        &:nth-child(2) {
          flex: 1;
        }

        &:nth-child(3) {
          flex: 2.187;
        }

        &:nth-child(4) {
          flex: 1;
        }

        &:nth-child(5) {
          flex: 0.697;
        }

        &:nth-child(6) {
          flex: 0.89;
        }
      }
    }

    &-stepimage {
      width: 1135px;
      height: auto;
      margin-top: 16px;
    }

    &-step {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 22px;
      width: 1135px;
      margin-top: 24px;
      padding-left: 135px;

      &-item {
        font-size: 16px;
        line-height: 1.2;
        font-weight: 700;
        color: #0f172a;
        height: 40px;
        border-radius: 8px;
        line-height: 40px;
        text-align: center;
        background: #ececec;
        flex: 1;

        &:nth-child(5) {
          flex: 1.73;
        }
      }
    }

    &-foot {
      display: flex;
      gap: 10px;
      width: 1135px;
      margin-top: 30px;
      padding-left: 135px;
      margin-left: -3px;
      padding-right: 30px;

      &-item {
        &:nth-child(1) {
          flex: 1;
        }

        &:nth-child(2) {
          flex: 1.71;
        }

        &:nth-child(3) {
          flex: 2.14;
        }

        .work-flow-sta-content-foot-item-title {
          border-radius: 0;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 0;
            border-top: 25px solid transparent;
            border-bottom: 25px solid transparent;
            border-left: 30px solid $white;
          }
        }

        &-title {
          font-size: 14px;
          line-height: 1.2;
          font-weight: 700;
          color: $grey-black;
          background: #f3e3c7;
          height: 50px;
          text-align: center;
          line-height: 50px;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            right: -30px;
            top: 0;
            width: 0;
            height: 0;
            border-top: 25px solid transparent;
            border-bottom: 25px solid transparent;
            border-left: 30px solid #f3e3c7;
            z-index: 1;
          }
        }

        &-subtitle {
          font-size: 14px;
          line-height: 1.2;
          font-weight: 700;
          margin-top: 12px;
          color: $grey-black;
          text-align: center;
        }
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      &-card {
        width: 100%;
      }

      &-stepimage {
        width: 100%;
      }

      &-step {
        width: 100%;
        padding-left: 10vw;
      }

      &-foot {
        width: 100%;
        padding-left: 10vw;
      }
    }
  }
}
</style>
